
const getSeededPRNG = seed => {
    //based on Alea from https://github.com/davidbau/seedrandom
    let n = 0xefc8249d, f = 2.3283064365386963e-10;
    var mash = data => {
        data = String(data);
        for (let i = 0; i < data.length; i++) {
            n += data.charCodeAt(i);
            let h = 0.02519603282416938 * n;
            n = h >>> 0;
            h -= n;
            h *= n;
            n = h >>> 0;
            h -= n;
            n += h * 0x100000000;
        }
        return (n >>> 0) * f;
    };
    // Apply the seeding algorithm from Baagoe.
    let c = 1, s0 = mash(' '), s1 = mash(' '), s2 = mash(' ');
    s0 -= mash(seed);
    if (s0 < 0) { s0 += 1; }
    s1 -= mash(seed);
    if (s1 < 0) { s1 += 1; }
    s2 -= mash(seed);
    if (s2 < 0) { s2 += 1; }
    //
    const next = () => {
        const t = 2091639 * s0 + c * f;
        s0 = s1;
        s1 = s2;
        return s2 = t - (c = t | 0);
    };
    next.seed = seed;
    return next;
}

/**
 * Fisher/Yates shuffling of Arrays. Shuffles array in place.
 * @param {Array} a 
 * @returns Array for chaining
 */
const shuffle = a => {
    for (let i = a.length; i; i--) {
        let j = (Math.random() * i) >> 0;
        let x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
    }
    return a;
}

const getRandomElement = (pool, exceptions) => {
    if (exceptions != null) {
        if (Array.isArray(exceptions)) {
            pool = pool.filter(elem => exceptions.indexOf(elem) == -1);
        } else {
            pool = pool.filter(elem => exceptions != elem);
        }
    }
    return pool[Math.floor(Math.random() * pool.length)];
}

export { getSeededPRNG, shuffle, getRandomElement };